<template>
  <div>
    <div class="row">
      <div class="col-10">
        <TaskSummaryWidget :gridHeight="250" />
      </div>
      <div class="col-2">
        <AnalyticsWidget title="Detailed Reports" subTitle="Click to access the detailed reports" :gridHeight="250">
          <div class="p-2">
            <AnalyticsReportLink href="/analytics/reports/production/despatch#tab-summary">Despatch Summary Report</AnalyticsReportLink>
            <AnalyticsReportLink href="/analytics/reports/production/despatch#tab-panel-list">Despatch Panel Report</AnalyticsReportLink>
          </div>
        </AnalyticsWidget>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <OrderDespatchBreakdownWidget :gridHeight="260" />
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <DashboardTabbedContentBox :gridHeight="630" large>
          <template v-slot:tablist>
            <Tab :first="true" tabid="tab-tasktype-item-daily">
              <i class="tabbedbox-tab-icon fas fa-tags"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Daily Task Types</div>
                <div class="tabbedbox-tab-subtitle">Task Scanned Item Chart</div>
              </div>
            </Tab>
            <Tab tabid="tab-tasktype-area-daily">
              <i class="tabbedbox-tab-icon fas fa-tags"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Daily Task Types</div>
                <div class="tabbedbox-tab-subtitle">Task Scanned Area Chart</div>
              </div>
            </Tab>
            <Tab tabid="tab-taskuser-item-daily">
              <i class="tabbedbox-tab-icon fas fa-user"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Daily Task User</div>
                <div class="tabbedbox-tab-subtitle">Task Scanned Item Chart</div>
              </div>
            </Tab>
            <Tab tabid="tab-taskuser-area-daily">
              <i class="tabbedbox-tab-icon fas fa-user"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Daily Task User</div>
                <div class="tabbedbox-tab-subtitle">Task Scanned Area Chart</div>
              </div>
            </Tab>
          </template>
          <template v-slot:tabcontent>
            <TabPage :first="true" tabid="tab-tasktype-item-daily" class="tabpage-padding-0">
              <TaskScannedItemDailyChartWidget :gridHeight="540" :embedded="true" :type="TaskDailyChartTypes.scannedItemTaskTypeQuantity" />
            </TabPage>
            <TabPage tabid="tab-tasktype-area-daily" class="tabpage-padding-0">
              <TaskScannedItemDailyChartWidget :gridHeight="540" :embedded="true" :type="TaskDailyChartTypes.scannedItemTaskTypeArea" />
            </TabPage>
            <TabPage tabid="tab-taskuser-item-daily" class="tabpage-padding-0">
              <TaskScannedItemDailyChartWidget :gridHeight="540" :embedded="true" :type="TaskDailyChartTypes.scannedItemPrimaryUserQuantity" />
            </TabPage>
            <TabPage tabid="tab-taskuser-area-daily" class="tabpage-padding-0">
              <TaskScannedItemDailyChartWidget :gridHeight="540" :embedded="true" :type="TaskDailyChartTypes.scannedItemPrimaryUserArea" />
            </TabPage>
          </template>
        </DashboardTabbedContentBox>
      </div>
    </div>

  </div>
</template>


<script>
import _ from 'lodash'
import moment from 'moment'

import DashboardTitle from '@/components/dashboard/dashboardTitle'
import DashboardContentBox from '@/components/dashboard/dashboardContentBox'
import DashboardTabbedContentBox from '@/components/dashboard/dashboardTabbedContentBox'
import AnalyticsDashboardHeader from '@/modules/intelligence/components/analyticsDashboardHeader'
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsReportLink from '@/modules/intelligence/components/analyticsReportLink'
import AnalyticsDashboardValue from '@/modules/intelligence/components/analyticsDashboardValue'

import TaskSummaryWidget from '@/modules/intelligence/dashboardWidgets/taskSummaryWidget'
import OrderDespatchBreakdownWidget from '@/modules/intelligence/dashboardWidgets/orderDespatchBreakdownWidget'
import TaskScannedItemDailyChartWidget from '@/modules/intelligence/dashboardWidgets/taskScannedItemDailyChartWidget'

import ReportFilterPopover from '@/components/reporting/reportFilterPopover'
import ReportDateRangeSelect from '@/components/reporting/reportDateRangeSelect'

import { ChartDateRangeTypes } from '@/modules/intelligence/types'

export default {
  name: 'AnalyticsTasksDashboard',
  components: {
    DashboardTitle,
    DashboardContentBox,
    DashboardTabbedContentBox,
    AnalyticsDashboardHeader,
    AnalyticsWidget,
    AnalyticsReportLink,
    AnalyticsDashboardValue,

    TaskSummaryWidget,
    OrderDespatchBreakdownWidget,
    TaskScannedItemDailyChartWidget,

    ReportFilterPopover,
    ReportDateRangeSelect
  },
  data() {
    return {
      
    }
  },
  created() {
    this.ChartDateRangeTypes = ChartDateRangeTypes
    this.TaskDailyChartTypes = TaskScannedItemDailyChartWidget.TaskDailyChartTypes
  },
  mounted() {
    
  },
  beforeDestroy() {
    
  },
  methods: {
    
  }
  
}
</script>